import { PREVIEW_CARD_DEMO } from './previewDemo';

export const TEMPLATE_VARIABLES = [
  { key: 'имя', label: 'Имя' },
  { key: 'фамилия', label: 'Фамилия' },
  { key: 'баланс', label: 'Баланс' },
  { key: 'кэшбэк', label: 'Кэшбэк %' },
  { key: 'номер_карты', label: 'Номер карты' },
  { key: 'уровень', label: 'Уровень карты' },
  { key: 'магазин', label: 'Название магазина' },
  { key: 'реферальный_код', label: 'Реферальный код' },
  { key: 'сумма_покупок', label: 'Сумма покупок' },
  { key: 'последние_покупки', label: 'Последние 5 покупок' },
  { key: 'осталось_потратить', label: 'До след. уровня, ₽' },
  { key: 'осталось_покупок', label: 'До след. уровня, покупок' },
];

const ALIASES = {
  name: 'имя',
  surname: 'фамилия',
  balance: 'баланс',
  cashback: 'кэшбэк',
  card_number: 'номер_карты',
  tier: 'уровень',
  store: 'магазин',
  referral_code: 'реферальный_код',
  purchases_total: 'сумма_покупок',
  last_purchases: 'последние_покупки',
  remaining_spend: 'осталось_потратить',
  remaining_purchases: 'осталось_покупок',
};

const PLACEHOLDER_RE = /\{\{\s*([а-яёa-z0-9_]+)\s*\}\}/gi;

function formatAmount(value) {
  return Number(value || 0).toLocaleString('ru-RU');
}

function formatPurchases(purchases) {
  if (!purchases?.length) return 'Нет покупок';
  return purchases
    .map((p) => {
      const date = p.createdAt ? new Date(p.createdAt).toLocaleDateString('ru-RU') : '—';
      const sum = p.total ?? p.amount ?? 0;
      return `${date} — ${formatAmount(sum)} ₽`;
    })
    .join('\n');
}

function formatNextLevelRemaining(card, template, purchaseCount) {
  if (!template?.nextTemplateId) {
    return { осталось_потратить: '—', осталось_покупок: '—' };
  }

  const rule = template.nextTemplateRule || 'amount';

  if (rule === 'purchases') {
    const threshold = template.nextTemplatePurchaseCount ?? 0;
    if (threshold <= 0) {
      return { осталось_потратить: '—', осталось_покупок: '—' };
    }
    return {
      осталось_потратить: '—',
      осталось_покупок: String(Math.max(0, threshold - purchaseCount)),
    };
  }

  const threshold = template.nextTemplateAmount ?? 0;
  if (threshold <= 0) {
    return { осталось_потратить: '—', осталось_покупок: '—' };
  }

  return {
    осталось_потратить: formatAmount(Math.max(0, threshold - (card?.saleAmount || 0))),
    осталось_покупок: '—',
  };
}

export function buildContextFromCard(card, style = {}) {
  const template = card?.template && typeof card.template === 'object' ? card.template : {};
  const store = card?.user && typeof card.user === 'object' ? card.user : {};
  const purchases = card.recentPurchases || [];
  const purchaseCount = card.purchaseCount ?? 0;
  const nextLevel = formatNextLevelRemaining(card, template, purchaseCount);

  return {
    имя: card?.name || '',
    фамилия: card?.surname || '',
    баланс: formatAmount(card?.balance),
    кэшбэк: `${style.cashback ?? template.cashback ?? 0}%`,
    номер_карты: card?.cardNumber || '',
    уровень: style.templateName || template.name || '',
    магазин: store.accountName || card?.accountName || '',
    реферальный_код: style.referralCode || card?.referralCode || '',
    сумма_покупок: formatAmount(card?.saleAmount),
    последние_покупки: formatPurchases(purchases),
    ...nextLevel,
  };
}

export const PREVIEW_TEMPLATE_CONTEXT = {
  имя: PREVIEW_CARD_DEMO.name,
  фамилия: PREVIEW_CARD_DEMO.surname,
  баланс: formatAmount(PREVIEW_CARD_DEMO.balance),
  кэшбэк: '5%',
  номер_карты: PREVIEW_CARD_DEMO.cardNumber,
  уровень: 'Стандарт',
  магазин: 'Магазин',
  реферальный_код: 'AB3K7MNP',
  сумма_покупок: '12 500',
  последние_покупки: '10.06.2026 — 1 250 ₽\n08.06.2026 — 890 ₽',
  осталось_потратить: '7 500',
  осталось_покупок: '3',
};

export function renderMessageTemplate(text, context) {
  if (!text) return '';
  return text.replace(PLACEHOLDER_RE, (_, rawKey) => {
    const normalized = rawKey.toLowerCase();
    const key = ALIASES[normalized] || normalized;
    return context[key] ?? '';
  });
}

export function insertTemplateVariable(text, key, selectionStart, selectionEnd) {
  const tag = `{{${key}}}`;
  const start = selectionStart ?? text.length;
  const end = selectionEnd ?? start;
  return text.slice(0, start) + tag + text.slice(end);
}
